<ng-container *ngIf="initialContent">
  <ng-container *ngIf="isAllowed && editMode; else readOnlyTemplate">
    <app-wysiwyg-editor
      #resourceeditor
      [isSaving]="isSaving"
      [version]="'full'"
      [config]="editorConfig"
      [editorContent]="initialContent"
      (editorContentEvent)="emitAutosave($event)" />
  </ng-container>
  <ng-template #readOnlyTemplate>
    <div class="overflow-auto resource-content">
      <app-safehtml
        [html]="initialContent"
        [classList]="['fr-view']"></app-safehtml>
    </div>
  </ng-template>
</ng-container>
